import { FC } from 'react';
import { RootComponent } from '../../services/root-component';
import { LayoutProps } from './types';
import css from './style.module.css';

export const Layout: FC<LayoutProps> = ({ rootRef, ...props }) => (
  <RootComponent
    {...props}
    Component="div"
    baseClassName={css.root}
    ref={rootRef}
  />
);
